import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { getPromotions } from 'actions/tenantProfileActions';

import TenantPromotionDialog from './components/promotions/TenantPromotionDialog';
import PromotionInfo from './components/promotions/PromotionInfo';

const DEFAULT_ROW_HEIGHT = 320;

export default connect(
  store => ({
    promotions: store.tenantProfile.promotions,
  }),
  { getPromotions }
)(
  class TenantPromotions extends Component {
    UNSAFE_componentWillMount() {
      this.props.getPromotions();
      this.setState({
        showPromotion: false,
        promotionDetails: {},
      });
    }

    togglePromotionDialog = promotionDetails => {
      this.setState({ showPromotion: !this.state.showPromotion, promotionDetails });
    };

    render() {
      let defaultHeight = DEFAULT_ROW_HEIGHT;

      const promotionCards = this.props.promotions.map(promotion => {
        return (
          <PromotionInfo
            key={promotion.id}
            promotion={promotion}
            defaultHeight={defaultHeight}
            openPromotionDialog={this.togglePromotionDialog}
          />
        );
      });

      return (
        <Fragment>
          <TenantPromotionDialog
            promotion={this.state.promotionDetails}
            togglePromotionDialog={this.togglePromotionDialog}
            showPromotion={this.state.showPromotion}
          />
          <div className="centers">
            <div style={{ padding: '0 10px' }}>
              {promotionCards}
              <div style={{ height: '15px' }} />
            </div>
          </div>
        </Fragment>
      );
    }
  }
);
